import {Component} from '@angular/core';
import {AlertController, Events, NavParams, ViewController} from 'ionic-angular';
import { CoffeShopService } from '../../providers/coffe-shop/coffe-shop.service';

/**
 * Generated class for the ServiceQuantityModal page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'service-quantity-modal',
    templateUrl: 'service-quantity-modal.html',
})
export class ServiceQuantityModal {

    loading: boolean = false;
    service: any;
    originalServiceQuantity: number;
    updatedService: any;
    numMaxServicesForBooking: number = null;
    selectedServicesCount: number;
    selectedServicesDuration: number;
    availableServiceDuration: any;
    currencySymbol: string;
    byStaff: boolean;
    public shopType: 'coffe' | 'barber';

    constructor(
      public viewCtrl: ViewController,
      public navParams: NavParams,
      public events: Events,
      private alertCtrl: AlertController,
      private coffeService: CoffeShopService
    ) {
        this.service = navParams.get('service');
        this.currencySymbol = navParams.get('currencySymbol');
        this.selectedServicesCount = navParams.get('selectedServicesCount');
        this.selectedServicesDuration = navParams.get('selectedServicesDuration');
        this.availableServiceDuration = navParams.get('availableServiceDuration');
        this.numMaxServicesForBooking = navParams.get('numMaxServicesForBooking') || null;
        this.updatedService = Object.assign({}, this.service);
        this.originalServiceQuantity = (this.service.quantity ? this.updatedService.quantity : 0);
        if (!this.service.quantity) this.updatedService.quantity = 1;
        this.byStaff = navParams.get('byStaff');
        this.shopType = navParams.get('shopType');
    }

    addQuantity(){
      if (this.updatedService && this.updatedService.available_count &&  this.updatedService.quantity >= this.updatedService.available_count ) {return;}
      if (this.shopType ==='coffe' && this.numMaxServicesForBooking !== null  && this.updatedService.quantity >= this.numMaxServicesForBooking) {
        this.validateMaxServiceQuantity();
        return;
      }
      this.updatedService.quantity++;

    }

    validateAvailableDuration(){

      if (this.availableServiceDuration){

        let serviceDuration = (this.updatedService.quantity - this.originalServiceQuantity) * this.service.duration;
        let totalServiceDuration = this.selectedServicesDuration + serviceDuration;

        if (this.availableServiceDuration < totalServiceDuration){

          let buttons = [];

          if (this.byStaff){
            buttons.push({
              text: 'Force add service time',
              handler: () => {
                this.addService(true);
              }
            });
          }

          buttons.push({
            text: 'Ok',
            role: 'cancel',
            handler: () => {
            }
          });

          let alert = this.alertCtrl.create({
            title: "Max Service Time Reached",
            subTitle: "Your booking must be less than or equal to the available " + this.availableServiceDuration + " minutes.",
            enableBackdropDismiss: false,
            buttons: buttons
          });
          alert.present();
          return false;
        }

      }

      return true;

    }

    validateMaxServiceQuantity() {
      this.coffeService.presentAlert(
        '',
      `Only ${this.service.stock} items of ${this.service.name} are available to order`,
      true, [{text: 'Ok'}]);
    }

    removeQuantity(){
      if (this.updatedService.quantity===0) return;
      this.updatedService.quantity--;
    }

    closeModal() {
        this.viewCtrl.dismiss();
    }

    addService(forceAdd:boolean = false){
      if (forceAdd=== true || this.validateAvailableDuration() === true){
        this.service.selected = true;
        this.service.quantity = this.updatedService.quantity;
        this.viewCtrl.dismiss({service: this.service});
      }
      return false;
    }

    removeService(){
      this.service.selected = false;
      this.service.quantity = 0;
      this.viewCtrl.dismiss({service: this.service});
    }
}


// WEBPACK FOOTER //
// ./src/pages/service-quantity-modal/service-quantity-modal.ts